import { render, staticRenderFns } from "./AtePlatTestingExer.vue?vue&type=template&id=0eb01dc8"
import script from "./AtePlatTestingExer.vue?vue&type=script&lang=js"
export * from "./AtePlatTestingExer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports